import { State } from 'xstate';
import { changePlan } from './changePlan';

type ChangePlanMachine = typeof changePlan;
type ChangePlanState = State<ChangePlanMachine['context']>;

export const getChangePlanStatus = (machineState: ChangePlanState) => ({
  configurePlanStep: machineState.matches('configurePlanStep'),
  configurePlanStepLoading: machineState.matches(
    'configurePlanStep.getProducts'
  ),
  previewPlanStep: machineState.matches('previewProductMigrationStep'),
  previewPlanLoading: machineState.matches(
    'configurePlanStep.getPreviewProductMigration'
  ),
  updatePlanLoading: machineState.matches(
    'previewProductMigrationStep.confirmProductMigration'
  ),
  updateSuccess: machineState.matches('previewProductMigrationStep.success'),
  isError:
    machineState.matches('configurePlanStep.error') ||
    machineState.matches('previewProductMigrationStep.error'),
});

export const getError = (machineState: ChangePlanState) => {
  return machineState.context.error;
};
export const getProducts = (machineState: ChangePlanState) => {
  return machineState.context.products;
};
export const getSelectedPlan = (machineState: ChangePlanState) => {
  return machineState.context.selectedPlan;
};
export const getChangePlanPreview = (machineState: ChangePlanState) => {
  return machineState.context.changePlanPreview;
};
export const changePlanSelectors = {
  getError,
  getChangePlanPreview,
  getProducts,
  getSelectedPlan,
  getChangePlanStatus,
};
